import React from 'react'

const AllRowsDialogContext = React.createContext()

export default AllRowsDialogContext
